import type { RoutingContextSourceResource } from '@/features/legends/api/resources/data-sources'
import type { DataSourcesConfigResource } from '@/features/legends/api/resources/legend'
import {
  mapUnknownResourceToElement,
  UnknownElementError,
} from '@/features/legends/editor/legend-document'
import type { DataSourcesConfig, RoutingContextSource } from './data-sources'

/**
 * Maps the legend's data sources.
 *
 * @param resource
 */
export function mapDataSourcesConfigResourceToConfig(
  resource: DataSourcesConfigResource,
): DataSourcesConfig {
  return {
    routingContextSources: resource.routing_context_sources?.map(
      mapRoutingContextSourceResourceToSource,
    ),
  }
}

/**
 * Maps the legend's data sources to the API's.
 *
 * @param config
 */
export function mapDataSourcesConfigToResource(
  config: DataSourcesConfig,
): DataSourcesConfigResource {
  return {
    routing_context_sources: config.routingContextSources?.map(
      mapRoutingContextSourceToResource,
    ),
  }
}

/**
 * Maps a routing context data source.
 *
 * @param resource
 */
export function mapRoutingContextSourceResourceToSource(
  resource: RoutingContextSourceResource,
): RoutingContextSource {
  switch (resource.type) {
    case 'ServiceItemPresence':
      return {
        type: 'ServiceItemPresence',
        id: resource.id,
        inventoryItemIds: resource.inventory_item_ids,
        op: resource.op,
      }
    case 'UserWorkRequestCount':
      return { type: 'UserWorkRequestCount', id: resource.id }
  }
  return mapUnknownResourceToElement(resource)
}

function mapRoutingContextSourceToResource(
  source: RoutingContextSource,
): RoutingContextSourceResource {
  switch (source.type) {
    case 'ServiceItemPresence':
      return {
        type: 'ServiceItemPresence',
        id: source.id,
        inventory_item_ids: source.inventoryItemIds,
        op: source.op,
      }
    case 'UserWorkRequestCount':
      return { type: 'UserWorkRequestCount', id: source.id }
    case 'Unknown':
      throw new UnknownElementError('routing data source', source)
  }
}
